import { Typography } from 'components/_common/Typography';
import React from 'react';

type RiskOverviewDetailColumnListItemProps = {
  itemText: string;
};

const RiskOverviewDetailColumnListItem: React.FC<RiskOverviewDetailColumnListItemProps> = ({
  itemText,
}) => {
  return (
    <li>
      <Typography variant="body2">{itemText}</Typography>
    </li>
  );
};

export default RiskOverviewDetailColumnListItem;
